import axios from "axios";
import { getToken, clearAuth } from "../utils/auth";

// const api = axios.create({ baseURL: "/api" });
const api = axios.create({ baseURL: "https://sales-server.itsvivek.in/api" });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      clearAuth();

      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);

// Auth
export const login = (data) => api.post("/auth/login", data);
export const resetPassword = (data) => api.post("/auth/reset-password", data);
export const sendOtp = (data) => api.post("/auth/send-otp", data);

// Users
export const getUsers = (params) => api.get("/users", { params });
export const getMyReports = () => api.get("/users/my-reports");
export const createUser = (data) => api.post("/users", data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/users/${id}`);
export const getUser = (id) => api.get(`/users/${id}`);
export const getUserProfile = () => api.get("/users/profile");
export const getDemoPersons = () => api.get("/users/demo-persons");

// Operators
export const getOperators = (params) => api.get("/operators", { params });
export const getOperator = (id) => api.get(`/operators/${id}`);
export const createOperator = (data) => api.post("/operators", data);
export const updateOperator = (id, data) => api.put(`/operators/${id}`, data);
export const getAllOperators = () => api.get("/operators/all-operators");

// Leads
export const getLeads = (params) => api.get("/leads", { params });
export const getLead = (id) => api.get(`/leads/${id}`);
export const createLead = (data) => api.post("/leads", data);
export const updateLeadStage = (id, data) =>
  api.put(`/leads/${id}/stage`, data);

// Demos
export const getDemos = (params) => api.get("/demos", { params });
export const bookDemo = (data) => api.post("/demos/book", data);
export const conductDemo = (id, data) => api.post(`/demos/conduct/${id}`, data);
export const cancelDemo = (id, data) => api.post(`/demos/cancel/${id}`, data);

// Attendance
export const getAttendance = (params) => api.get("/attendance", { params });
export const checkIn = (data) => api.post("/attendance/check-in", data);
export const checkOut = (data) => api.post("/attendance/check-out", data);

// Media
export const uploadMedia = (formData) =>
  api.post("/media/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
export const getMediaByOperator = (operatorId, params) =>
  api.get(`/media/${operatorId}`, { params });

// Config
export const getConfig = () => api.get("/config");
export const updateConfig = (data) => api.put("/config", data);

// Audit
export const getAuditLogs = (params) => api.get("/audit", { params });

// Dashboard
export const getDashboard = () => api.get("/dashboard");

export default api;
